import React from 'react';
import { DNABox, DNACard, DNAText, useTheme } from '@alucio/lux-ui';
import { DNACardComponent, DNAChip, DNACustomDeckThumbnail } from 'src/components/DNA';
import { isCustomDeckORM, FolderItemORM } from 'src/types/types';

const DNACustomDeckVirtualCard: DNACardComponent<FolderItemORM> = (props) => {
  const { ORM: folderItemORM, onPress } = props
  const theme = useTheme()
  if (!isCustomDeckORM(folderItemORM.relations.itemORM)) {
    throw Error('ORM received in props must be a custom deck');
  }
  const customDeckORM = folderItemORM.relations.itemORM

  return (
    <DNABox
      alignX="start"
      style={{ minWidth: 232, minHeight: 212 }}
    >
      <DNACard
        interactive="pressable"
        onPress={() => { onPress?.(folderItemORM) }}
        style={{
          padding: 8,
          backgroundColor: theme['color-dark-300'],
        }}
      >
        <DNABox appearance="col" spacing="sm">
          <DNABox style={{ backgroundColor: theme['color-dark-transparent-700'] }}>
            <DNACustomDeckThumbnail
              customDeckORM={customDeckORM}
              width={216}
              height={124}
              unavailableContent={false}
            />
          </DNABox>
          <DNABox appearance="col" spacing="sm">
            <DNAText
              colorMode="dark"
              b2
              style={{ width: 216, overflow: 'hidden' }}
              numberOfLines={2}
            >
              {folderItemORM.model.customTitle ? folderItemORM.model.customTitle : 'Untitled Presentation'}
            </DNAText>
            <DNABox spacing="sm" appearance="row">
              <DNAChip.Beacon variant="MODIFIED" />
            </DNABox>
          </DNABox>
        </DNABox>
      </DNACard>
    </DNABox>
  )
}

export default DNACustomDeckVirtualCard
